<template>
  <div class="address">
    <div class="dangerous-goods-dropdown" data-toggle="dropdown">
      <un-selector-item
        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
        :newdangerousGood="newDangerousGoods"
        :dangerousGood="selected"
        @showForm="$emit('showForm', selected)"
      ></un-selector-item>
    </div>
    <div class="dropdown-menu address-menu btn-block">
      <div
        class="options-holder"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <input
          ref="filter"
          type="text"
          v-model="searchText"
          placeholder="Search your dangerous goods here, enter a product code or name"
          style="padding: 0.25rem 0.50rem 0.25rem 0.50rem; margin-bottom: 0.5rem; width: 90%; border: 1px solid lightslategray;
               border-radius: 0.25rem; font-size: 1rem;"
          autofocus
          tabindex="-1"
        />
        <span
          class="dropdown-divider"
          style="width: 100%; margin-top: 0;"
        ></span>
      </div>
      <div class="options-holder">
        <div
          v-for="(dangerousGood, index) in dangerousGoods"
          :key="index"
          @click="clear()"
        >
          <un-selector-item
            :dangerousGood="dangerousGood"
            @click.native.prevent="
              $emit('changed', { good: dangerousGood, text: searchText })
            "
            @showForm="$emit('showForm', dangerousGood)"
          ></un-selector-item>
          <div
            v-if="index < dangerousGoods.length - 1"
            class="dropdown-divider"
          ></div>
        </div>
      </div>
      <div class="text-center">
        <div class="dropdown-divider" style="margin-top: 0"></div>
        <button
          type="button"
          class="btn-link"
          @click="$emit('showForm', null, lineIndex)"
        >
          <i class="far fa-plus-circle"></i> Add New Dangerous Good
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UnSelectorItem from "./UnSelectorItem";

export default {
  name: "un-selector",
  components: { UnSelectorItem },
  props: [
    "initialDangerousGoods",
    "selected",
    "lineIndex",
    "newDangerousGoods"
  ],
  data() {
    return {
      dangerousGoods: this.initialDangerousGoods,
      searchText: ""
    };
  },
  watch: {
    searchText: function(val) {
      val = val.trim().toUpperCase();

      if (val === "") {
        this.dangerousGoods = this.initialDangerousGoods;
      } else {
        let that = this;

        this.dangerousGoods = this.initialDangerousGoods.filter(
          dangerousGood => {
            if (!dangerousGood || !dangerousGood.name) {
              return false;
            }

            if (dangerousGood.name.toUpperCase().includes(val)) {
              return true;
            }

            if (dangerousGood.unDetails.toUpperCase().includes(val)) {
              return true;
            }

            if (dangerousGood.un.data.un_number.includes(val)) {
              return true;
            }

            if (dangerousGood.hasOwnProperty("sizes")) {
              if (
                dangerousGood.sizes.data.filter(size => {
                  if (size.product_id == dangerousGood.id) {
                    if (size.code !== null) {
                      if (size.code.includes(that.searchText)) {
                        return true;
                      }
                    }
                  }

                  // }
                }).length > 0
              ) {
                return true;
              }
            }
            return false;
          }
        );
      }
    }
  },

  methods: {
    clear() {
      this.searchText = "";
    }
  }
};
</script>

<style scoped>
.dropdown-menu {
  transform: translate3d(0px, 38px, 0px) !important;
}
</style>
